/**
 * Storefront 1:1 booking calendar. Talks to /apps/phoera/booking (app proxy)
 * and sends the shopper to Shopify /cart/add — they never leave this domain.
 */
(function () {
  "use strict";

  var ENDPOINT = "/apps/phoera/booking";

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  var GROUP_TIERS = [
    { min: 1, max: 1, label: "Private 1-on-1 session" },
    { min: 2, max: 9, label: "Small group (2-9 people)" },
    { min: 10, max: 20, label: "Group (10-20 people)" },
    { min: 21, max: 30, label: "Large group (21-30 people)" },
    { min: 31, max: 40, label: "Workshop (31-40 people)" },
    { min: 41, max: 50, label: "Corporate workshop (41-50 people)" },
  ];

  function money(n) {
    return "R " + Number(n || 0).toFixed(2);
  }

  function shopMoney(n) {
    var parts = Number(n || 0).toFixed(2).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return "R " + parts.join(".");
  }

  var WORTH_EACH = 2500;

  function syncNativePrice(quote) {
    var wrap = document.querySelector(".main-product__block-price");
    if (!wrap || !quote) return;
    var people = Math.max(1, parseInt(quote.people, 10) || 1);
    var pay = shopMoney(quote.total);
    var worth = shopMoney(WORTH_EACH * people);
    var box = wrap.querySelector(".m-price");
    if (box) box.classList.add("m-price--on-sale");
    wrap.querySelectorAll(".m-price-item--sale").forEach(function (el) {
      if (el.tagName !== "S") el.textContent = pay;
    });
    wrap.querySelectorAll(".m-price-item--regular").forEach(function (el) {
      el.textContent = worth;
    });
    var saved = wrap.querySelector("[data-saved-price]");
    if (saved) saved.textContent = shopMoney(Math.max(0, WORTH_EACH * people - Number(quote.total || 0)));
    var badge = wrap.querySelector(".m-price__badge-sale");
    if (badge) badge.hidden = false;
  }

  function groupTierLabel(qty) {
    var n = Math.max(1, Math.min(50, parseInt(qty, 10) || 1));
    var label = GROUP_TIERS[0].label;
    GROUP_TIERS.forEach(function (t) {
      if (n >= t.min) label = t.label;
    });
    return label;
  }

  function unitRands(tiers, priceRands, qty) {
    var n = Math.max(1, parseInt(qty, 10) || 1);
    var unit = Number(priceRands || 0);
    (tiers || []).forEach(function (t) {
      if (Number(t.qty) > n) return;
      if (t.each != null && t.each !== "") unit = Number(t.each);
      else unit = Number(priceRands || 0) * (1 - (Number(t.percent) || 0) / 100);
    });
    return unit;
  }

  function priceQuote(tiers, priceCents, qty, maxPeople) {
    var max = Math.max(1, Math.min(50, parseInt(maxPeople, 10) || 50));
    var people = Math.max(1, Math.min(max, parseInt(qty, 10) || 1));
    var priceRands = Number(priceCents || 0) / 100;
    var rawUnit = unitRands(tiers, priceRands, people);
    var rawTotal = rawUnit * people;
    var bestTotal = rawTotal;
    var chargedQty = people;
    for (var n = people + 1; n <= max; n += 1) {
      var total = unitRands(tiers, priceRands, n) * n;
      if (total < bestTotal) {
        bestTotal = total;
        chargedQty = n;
      }
    }
    var capped = chargedQty > people && bestTotal < rawTotal;
    return {
      people: people,
      rawUnit: rawUnit,
      rawTotal: rawTotal,
      chargedQty: chargedQty,
      chargedUnit: bestTotal / chargedQty,
      total: bestTotal,
      capped: capped,
      tierLabel: groupTierLabel(chargedQty),
    };
  }

  function weekChunks(days) {
    var out = [];
    for (var i = 0; i < days.length; i += 7) out.push(days.slice(i, i + 7));
    return out.filter(function (w) {
      return w.length;
    });
  }

  function timeLabel(iso, tz) {
    try {
      return new Date(iso).toLocaleTimeString("en-ZA", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: tz || "Africa/Johannesburg",
      });
    } catch (_e) {
      return "";
    }
  }

  function el(tag, attrs, html) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === "class") node.className = attrs[k];
        else if (k === "text") node.textContent = attrs[k];
        else node.setAttribute(k, attrs[k]);
      });
    }
    if (html != null) node.innerHTML = html;
    return node;
  }

  function mount(root) {
    if (!root || root.getAttribute("data-phoera-ready")) return;
    root.setAttribute("data-phoera-ready", "1");

    var state = {
      data: null,
      people: 1,
      start: "",
      weekI: 0,
      error: "",
      busy: false,
    };

    function availableTiers() {
      var max = maxQty();
      return GROUP_TIERS.filter(function (t) {
        return t.min <= max;
      });
    }

    function currentTier() {
      var n = qty();
      var list = availableTiers();
      var hit = list[0] || GROUP_TIERS[0];
      list.forEach(function (t) {
        if (n >= t.min) hit = t;
      });
      return hit;
    }

    function maxQty() {
      if (!state.data) return 1;
      var session = state.data.session || {};
      return Math.max(1, Math.min(50, session.maxPeople || 50));
    }

    function qty() {
      var max = maxQty();
      if (max < 1) return 0;
      return Math.max(1, Math.min(max, state.people));
    }

    function starts() {
      return ((state.data && state.data.slots) || []).map(function (s) {
        return { start: s.start, label: s.label, following: [s.label] };
      });
    }

    function render() {
      var data = state.data;
      if (!data) {
        root.innerHTML = '<p class="phoera-booking__muted">Loading available times…</p>';
        return;
      }
      if (data.error && !data.session) {
        root.innerHTML = '<p class="phoera-booking__error">' + escapeHtml(data.error) + "</p>";
        return;
      }

      var session = data.session || {};
      var max = maxQty();
      var n = qty();
      var weeks = weekChunks(data.days || []);
      if (state.weekI > weeks.length - 1) state.weekI = Math.max(0, weeks.length - 1);
      var week = weeks[state.weekI] || [];
      var startSet = {};
      starts().forEach(function (s) {
        startSet[s.start] = s;
      });
      var quote = priceQuote(session.discounts, session.priceCents, n, session.maxPeople || 50);
      var chosen = startSet[state.start] || null;
      var tz = session.timezone || "Africa/Johannesburg";
      var closed = !session.active || !data.hasProduct || max < 1;

      var html = "";
      var tier = currentTier();

      if (closed) {
        html +=
          '<p class="phoera-booking__error">' +
          (!session.active
            ? "Bookings are closed."
            : !data.hasProduct
              ? "This session is not open for checkout yet."
              : "No session times are open.") +
          "</p>";
        root.innerHTML = html;
        return;
      }

      html += '<label class="phoera-booking__label" for="phoera-booking-group">Group type</label>';
      html += '<select class="phoera-booking__select" id="phoera-booking-group" data-act="tier">';
      availableTiers().forEach(function (t) {
        var hi = Math.min(t.max, session.maxPeople || 50);
        var atMin = priceQuote(session.discounts, session.priceCents, t.min, session.maxPeople || 50);
        var peopleLabel = t.min === hi ? t.min + " person" : t.min + "–" + hi + " people";
        html +=
          '<option value="' +
          t.min +
          '"' +
          (t.min === tier.min ? " selected" : "") +
          ">" +
          escapeHtml(t.label) +
          " · " +
          peopleLabel +
          " · " +
          money(atMin.rawUnit) +
          " per person</option>";
      });
      html += "</select>";
      html +=
        '<p class="phoera-booking__muted" style="margin-top:8px;font-size:12px">Bigger groups pay less per person. If a larger group would cost less in total, we cap your price so you never pay more than they would.</p>';

      html += '<label class="phoera-booking__label">How many tickets</label>';
      html += '<div class="phoera-booking__stepper">';
      html +=
        '<button type="button" class="phoera-booking__step-btn" data-act="minus" aria-label="Fewer tickets"' +
        (n <= 1 ? " disabled" : "") +
        ">−</button>";
      html +=
        '<input class="phoera-booking__step-input" data-act="qty" type="number" inputmode="numeric" min="1" max="' +
        max +
        '" value="' +
        n +
        '" autocomplete="off">';
      html +=
        '<button type="button" class="phoera-booking__step-btn" data-act="plus" aria-label="More tickets"' +
        (n >= max ? " disabled" : "") +
        ">+</button>";
      html += "</div>";
      html +=
        '<p class="phoera-booking__muted" style="margin-top:6px;font-size:13px">' +
        "Up to " +
        session.maxPeople +
        " people in one session · one ticket per person</p>";

      html += '<div class="phoera-booking__price">' + priceInner(quote, n, session) + "</div>";

      html += '<label class="phoera-booking__label">Pick a day this week</label>';
      html +=
        '<p class="phoera-booking__muted" style="margin:0 0 8px;font-size:13px">Workshop dates, taken times, and days the artist marked off are blocked. A time is not available in the 2 hours before it starts. Your whole group shares one ' +
        session.slotMinutes +
        "-minute session at the time you pick (up to " +
        (session.maxPeople || 50) +
        " people).</p>";

      html += '<div class="phoera-booking__week-nav">';
      html +=
        '<button type="button" class="phoera-booking__week-btn" data-act="prev"' +
        (state.weekI <= 0 ? " disabled" : "") +
        ">Previous week</button>";
      html += "<strong style='font-size:14px'>";
      if (week[0]) html += week[0].day + " " + week[0].month;
      if (week[6]) html += " – " + week[6].day + " " + week[6].month;
      html += "</strong>";
      html +=
        '<button type="button" class="phoera-booking__week-btn" data-act="next"' +
        (state.weekI >= weeks.length - 1 ? " disabled" : "") +
        ">Next week</button>";
      html += "</div>";

      html += '<div class="phoera-booking__grid">';
      week.forEach(function (day) {
        var open = day.status === "open" ? (day.slots || []).filter(function (s) { return startSet[s.start]; }) : [];
        var cls = "phoera-booking__day";
        if (day.status === "event" || day.status === "booked") cls += " is-blocked";
        else if (day.status === "closed" || day.status === "past" || day.status === "full") cls += " is-muted";
        html += '<div class="' + cls + '">';
        html += '<div class="phoera-booking__day-name">' + escapeHtml(day.weekdayLabel || "") + "</div>";
        html += '<div class="phoera-booking__day-date">' + day.day + " " + day.month + "</div>";
        if (day.status === "open" && open.length) {
          open.forEach(function (slot) {
            var on = slot.start === state.start;
            html +=
              '<button type="button" class="phoera-booking__slot' +
              (on ? " is-on" : "") +
              '" data-act="slot" data-start="' +
              escapeAttr(slot.start) +
              '">' +
              escapeHtml(timeLabel(slot.start, tz));
            html += "</button>";
          });
        } else {
          var reason =
            day.status === "event" || day.status === "booked"
              ? day.reason
              : day.status === "closed"
                ? "Unavailable"
                : day.status === "past"
                  ? "Past"
                  : day.status === "full"
                    ? "No free slots"
                    : "Unavailable";
          html += '<div class="phoera-booking__reason">' + escapeHtml(reason || "Unavailable") + "</div>";
        }
        html += "</div>";
      });
      html += "</div>";

      if (chosen) {
        html +=
          '<p class="phoera-booking__muted" style="font-size:13px;margin-top:10px">' +
          n +
          (n === 1 ? " person" : " people") +
          " · one session · " +
          escapeHtml(chosen.label) +
          "</p>";
      }
      if (state.error) {
        html += '<p class="phoera-booking__error">' + escapeHtml(state.error) + "</p>";
      }
      html +=
        '<button type="button" class="phoera-booking__submit" data-act="go"' +
        (state.busy || !state.start ? " disabled" : "") +
        ">" +
        (state.busy ? "Holding your time…" : "Continue to checkout") +
        "</button>";
      html +=
        '<p class="phoera-booking__hint">We hold this session for 20 minutes while you pay. Cancelled orders release the time.</p>';

      root.innerHTML = html;
      syncNativePrice(quote);
    }

    function priceInner(quote, n, session) {
      var html = "<strong>" + money(quote.rawUnit) + " per person</strong>";
      if (quote.capped) {
        html += '<div class="phoera-booking__was">' + money(quote.rawTotal) + "</div>";
        html +=
          '<div class="phoera-booking__cap">Capped to ' +
          escapeHtml(quote.tierLabel) +
          " × " +
          quote.chargedQty +
          "</div>";
      }
      html += '<div class="phoera-booking__price-total">' + money(quote.total) + "</div>";
      html +=
        '<div class="phoera-booking__muted" style="margin:4px 0 0;font-size:12px">' +
        n +
        (n === 1 ? " person" : " people") +
        " in one " +
        session.slotMinutes / 60 +
        "-hour session</div>";
      return html;
    }

    function syncQtyUi() {
      if (!state.data || !state.data.session) return;
      var session = state.data.session;
      var n = qty();
      var max = maxQty();
      var quote = priceQuote(session.discounts, session.priceCents, n, session.maxPeople || 50);
      var sel = root.querySelector("[data-act='tier']");
      if (sel) sel.value = String(currentTier().min);
      var box = root.querySelector(".phoera-booking__price");
      if (box) box.innerHTML = priceInner(quote, n, session);
      syncNativePrice(quote);
      var minus = root.querySelector("[data-act='minus']");
      var plus = root.querySelector("[data-act='plus']");
      if (minus) minus.disabled = n <= 1;
      if (plus) plus.disabled = n >= max;
    }

    function applyTypedQty(raw, clampEmpty) {
      var max = maxQty();
      if (raw === "" || raw === "-") {
        if (clampEmpty) state.people = 1;
        return;
      }
      var n = parseInt(raw, 10);
      if (!Number.isFinite(n)) return;
      state.people = Math.max(1, Math.min(max, n));
      syncQtyUi();
    }

    function onClick(e) {
      var btn = e.target.closest("[data-act]");
      if (!btn || !root.contains(btn)) return;
      var act = btn.getAttribute("data-act");
      if (act === "minus") {
        state.people = Math.max(1, qty() - 1);
        render();
      } else if (act === "plus") {
        state.people = Math.min(maxQty(), qty() + 1);
        render();
      } else if (act === "prev") {
        state.weekI = Math.max(0, state.weekI - 1);
        render();
      } else if (act === "next") {
        state.weekI += 1;
        render();
      } else if (act === "slot") {
        state.start = btn.getAttribute("data-start") || "";
        state.error = "";
        render();
      } else if (act === "go") {
        submit();
      }
    }

    function onInput(e) {
      var t = e.target;
      if (!t || !root.contains(t)) return;
      if (t.getAttribute("data-act") === "qty") applyTypedQty(t.value, false);
    }

    function onChange(e) {
      var t = e.target;
      if (!t || !root.contains(t)) return;
      var act = t.getAttribute("data-act");
      if (act === "qty") {
        applyTypedQty(t.value, true);
        t.value = String(qty());
        render();
      } else if (act === "tier") {
        var min = parseInt(t.value, 10) || 1;
        var next = GROUP_TIERS.find(function (g) {
          return g.min === min;
        });
        state.people = next ? next.min : min;
        if (state.people > maxQty()) state.people = maxQty();
        render();
      }
    }

    async function load() {
      try {
        var res = await fetch(ENDPOINT + "?people=" + encodeURIComponent(qty() || 1), {
          credentials: "same-origin",
        });
        var data = await res.json();
        state.data = data;
        if (data && data.days) {
          var idx = data.days.findIndex(function (d) {
            return d.status === "open";
          });
          state.weekI = idx < 0 ? 0 : Math.floor(idx / 7);
        }
      } catch (_e) {
        state.data = { error: "Could not load available times." };
      }
      render();
    }

    async function submit() {
      if (state.busy || !state.start) return;
      state.busy = true;
      state.error = "";
      render();
      try {
        var res = await fetch(ENDPOINT, {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            start: state.start,
            people: qty(),
          }),
        });
        var data = await res.json().catch(function () {
          return {};
        });
        if (data && data.ok && data.checkoutUrl) {
          window.location.href = data.checkoutUrl;
          return;
        }
        state.error = (data && data.error) || "Could not reserve that time";
      } catch (_e) {
        state.error = "Could not reserve that time";
      }
      state.busy = false;
      render();
    }

    root.addEventListener("click", onClick);
    root.addEventListener("change", onChange);
    root.addEventListener("input", onInput);
    load();
  }

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  function escapeAttr(s) {
    return escapeHtml(s);
  }

  function boot() {
    document.querySelectorAll("[data-phoera-booking]").forEach(mount);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
